import React from "react";
import { useI18n, useL } from "@/context/I18nContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
];

export default function LanguageSelector() {
  const { lang, changeLang } = useI18n();
  const L = useL();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector"
          className="inline-flex items-center gap-1.5 rounded-md border border-white/10 px-2.5 h-9 text-sm text-slate-300 hover:bg-white/5 transition-colors"
        >
          <Globe className="h-4 w-4" />
          <span className="uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            disabled={l.disabled}
            onClick={() => !l.disabled && changeLang(l.code)}
            className={lang === l.code ? "text-gold" : ""}
          >
            {l.label}
            {l.disabled && <span className="ml-auto text-[10px] text-slate-500">{L("prossim.", "soon", "bald")}</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
